(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
  class ExternalLazyVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.sources = this.querySelectorAll('source[data-src]');
      if (!this.video || !this.sources.length) return;

      this.handleToggle = this.togglePlayback.bind(this);
      this.handleKeydown = this.handleKeyboardToggle.bind(this);
      this.addEventListener('click', this.handleToggle);
      this.addEventListener('keydown', this.handleKeydown);

      this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
        rootMargin: '400px 0px',
        threshold: 0.01
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleToggle);
      this.removeEventListener('keydown', this.handleKeydown);
      if (this.observer) this.observer.disconnect();
    }

    handleIntersect(entries) {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        this.loadVideo();
        if (this.observer) this.observer.disconnect();
      }
    }

    loadVideo() {
      if (this.dataset.loaded === 'true') return;
      for (const source of this.sources) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      }
      this.video.load();
      this.dataset.loaded = 'true';
      this.video.play().catch(() => {});
    }

    togglePlayback() {
      this.loadVideo();
      if (this.video.paused) {
        this.video.play().catch(() => {});
        return;
      }
      this.video.pause();
    }

    handleKeyboardToggle(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.togglePlayback();
    }
  }

  if (!customElements.get('external-lazy-video')) {
    customElements.define('external-lazy-video', ExternalLazyVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsock-callixe-steps"] && !Shopify.designMode) return;
  try {
    
  class PulsockCallixeSteps extends HTMLElement {
    constructor() {
      super();
      this.scroller = null;
      this.items = [];
      this.dots = [];
      this.frame = null;
      this.onScroll = this.onScroll.bind(this);
      this.onDotClick = this.onDotClick.bind(this);
    }

    connectedCallback() {
      this.scroller = this.querySelector('.pulsock-callixe-steps__grid');
      this.items = [...this.querySelectorAll('.pulsock-callixe-steps__item')];
      this.dots = [...this.querySelectorAll('.pulsock-callixe-steps__dot')];

      if (!this.scroller || this.items.length === 0 || this.dots.length === 0) return;

      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      for (const dot of this.dots) {
        dot.addEventListener('click', this.onDotClick);
      }
      this.updateActiveDot();
    }

    disconnectedCallback() {
      if (this.scroller) {
        this.scroller.removeEventListener('scroll', this.onScroll);
      }

      for (const dot of this.dots) {
        dot.removeEventListener('click', this.onDotClick);
      }

      if (this.frame) {
        window.cancelAnimationFrame(this.frame);
      }
    }

    onScroll() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        this.updateActiveDot();
      });
    }

    onDotClick(event) {
      const index = Number(event.currentTarget.dataset.stepDot);
      const item = this.items[index];
      if (!item) return;

      item.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }

    updateActiveDot() {
      const scrollerRect = this.scroller.getBoundingClientRect();
      const scrollerCenter = scrollerRect.left + scrollerRect.width / 2;
      let activeIndex = 0;
      let activeDistance = Infinity;

      for (const item of this.items) {
        const index = Number(item.dataset.stepIndex);
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.left + rect.width / 2;
        const distance = Math.abs(itemCenter - scrollerCenter);
        if (distance < activeDistance) {
          activeDistance = distance;
          activeIndex = index;
        }
      }

      for (const dot of this.dots) {
        const isActive = Number(dot.dataset.stepDot) === activeIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      }
    }
  }

  if (!customElements.get('pulsock-callixe-steps')) {
    customElements.define('pulsock-callixe-steps', PulsockCallixeSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsock-lumbar-package-specs"] && !Shopify.designMode) return;
  try {
    
  class PulsockLumbarPackageSpecs extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;

      const panelName = tab.dataset.panel;
      if (!panelName) return;

      const tabs = this.querySelectorAll('[role="tab"]');
      const panels = this.querySelectorAll('[data-panel-id]');

      for (const item of tabs) {
        item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
      }

      for (const panel of panels) {
        panel.hidden = panel.dataset.panelId !== panelName;
      }
    }
  }

  if (!customElements.get('pulsock-lumbar-package-specs')) {
    customElements.define('pulsock-lumbar-package-specs', PulsockLumbarPackageSpecs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsock-lumbar-pdp"] && !Shopify.designMode) return;
  try {
    
  class PulsockLumbarPdp extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      const video = event.target.closest('video');
      if (!video || !this.contains(video)) return;
      if (video.hasAttribute('data-pulsock-autoplay-video')) return;

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }
  }

  if (!customElements.get('pulsock-lumbar-pdp')) {
    customElements.define('pulsock-lumbar-pdp', PulsockLumbarPdp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsock-lumbar-three-step-videos"] && !Shopify.designMode) return;
  try {
    
  class PulsockLumbarVideoSteps extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      const video = event.target.closest('video');
      if (!video || !this.contains(video)) return;
      if (video.hasAttribute('data-pulsock-autoplay-video')) return;

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }
  }

  if (!customElements.get('pulsock-lumbar-video-steps')) {
    customElements.define('pulsock-lumbar-video-steps', PulsockLumbarVideoSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsock-lumbar-video-hero"] && !Shopify.designMode) return;
  try {
    
  class PulsockLumbarVideoHero extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      if (!this.video || event.target.closest('[data-pulsock-autoplay-video]')) return;

      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }
  }

  if (!customElements.get('pulsock-lumbar-video-hero')) {
    customElements.define('pulsock-lumbar-video-hero', PulsockLumbarVideoHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsock-posture-media-hero"] && !Shopify.designMode) return;
  try {
    
  class PulsockLumbarVideoHero extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      if (!this.video || event.target.closest('[data-pulsock-autoplay-video]')) return;

      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }
  }

  if (!customElements.get('pulsock-lumbar-video-hero')) {
    customElements.define('pulsock-lumbar-video-hero', PulsockLumbarVideoHero);
  }

  } catch(e) { console.error(e); }
})();
})();
